// Resumo da matriz de correlacao para os contextos de IA. A mesma
// conta existia duplicada em dois lugares do App.js, com texto
// diferente em cada um: a analise 💠 nomeia o par mais alto, a
// one-shot da so o valor. Os numeros batiam, mas nada impedia que
// divergissem numa mexida futura — e duas medias diferentes para a
// mesma carteira em duas abas seria o pior tipo de erro, o que nao
// quebra nada e so mente.
//
// Triangulo superior apenas (t < t2): sem diagonal e sem par
// repetido. Math.abs porque a frase fala de intensidade. Medido em
// 09/10/2026, entre oito ativos desse perfil em 251 dias, a
// correlacao mais baixa foi BAC-GLD com +0.142 e nenhuma foi
// negativa, entao |r| = r na pratica. Se algum dia entrar ativo que
// correlacione negativo, o modulo passa a tratar hedge como
// concentracao e esta conta precisa de revisao.
//
// O (row || {}) e protecao nova: antes uma linha nula da matriz
// estouraria dentro da IIFE e derrubaria a analise inteira. Nao
// altera saida em nenhum caso que funcionava.
export function correlacaoResumo(c) {
  const v = []
  let mxV = 0
  let mxPar = ""
  Object.entries(c || {}).forEach(([t, row]) =>
    Object.entries(row || {}).forEach(([t2, val]) => {
      if (t < t2) {
        const a = Math.abs(val)
        v.push(a)
        if (a > mxV) {
          mxV = a
          mxPar = t + "x" + t2
        }
      }
    }))
  const avg = v.length ? v.reduce((a, b) => a + b, 0) / v.length : 0
  return { n: v.length, avg: avg, mx: mxV, par: mxPar }
}


// Texto de Risk Contribution para o contexto de IA.
// Vivia dentro da linha de 10 KB do system: do chat.
// A conta e peso x volatilidade normalizado, que ignora a
// covariancia. Medido em 09/10/2026 na carteira real (FBTC
// 75%, ETHA 25%, correlacao 0.92): simples da 69,7/30,3 e a
// correta por covariancia da 70,4/29,6 — sete decimos de
// ponto, porque a aproximacao e exata quando as correlacoes
// valem 1 e aqui valem 0,92. Numa carteira de fato
// diversificada ela erraria, e ai esta conta precisa mudar.
// O proprio texto enviado ao modelo declara a convencao.
export function textoRisco(etfEnriched, positionStats) { const tv = etfEnriched.reduce((s,p)=>s+(p.value||0),0); const st = positionStats || {}; const volDe = x => parseFloat(st[x.symbol]?.volatility) || 0; const totR = etfEnriched.reduce((a,x) => a + (tv>0?(x.value||0)/tv*100:0) * volDe(x), 0); const semDado = etfEnriched.filter(x => volDe(x) <= 0).map(x => x.symbol); return etfEnriched.map(p => { const peso = tv>0?((p.value||0)/tv*100):0; const vol = volDe(p); const risco = totR>0 ? peso*vol/totR*100 : 0; return p.symbol + " risco=" + (vol>0?risco.toFixed(1)+"%":"sem dados") + " peso=" + peso.toFixed(1) + "% vol=" + (vol>0?vol.toFixed(1)+"%":"n/d") }).join(", ") + (semDado.length ? ". Sem volatilidade calculada (historico curto): " + semDado.join(", ") : "") }
